import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/digital_consulting_logo.webp";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: "Servicios", id: "ecosystem" },
    { label: "Resultados", id: "cases" },
    { label: "Proceso", id: "process" },
    { label: "FAQ", id: "faq" },
    { label: "Contacto", id: "contact" },
  ];

  return (
    <header className="fixed top-0 w-full z-50 bg-background/95 backdrop-blur-md border-b border-border">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
        <div className="flex justify-between items-center h-14 sm:h-16">
          <div className="flex-shrink-0">
            <a href="#inicio" className="block" aria-label="Ir al inicio">
              <img src={logo} alt="Digital Consulting" className="h-20 sm:h-24 lg:h-32 w-auto" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-6 lg:space-x-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={`#${item.id}`}
                className="text-sm lg:text-base text-primary hover:text-accent transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-1">
            <Button
              size="sm"
              className="hidden md:inline-flex bg-primary hover:bg-primary-hover text-primary-foreground rounded-full text-sm font-medium px-5"
              onClick={() => {
                window.open(`https://wa.me/50670473873?text=${encodeURIComponent("Hola! Me interesa conocer más sobre sus servicios.")}`, '_blank');
              }}
            >
              Hablemos
            </Button>

            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden w-9 h-9"
              aria-label={isMenuOpen ? "Cerrar menu" : "Abrir menu"}
            >
              {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>

        {/* Mobile Nav */}
        {isMenuOpen && (
          <div className="md:hidden py-3 border-t border-border bg-background">
            <div className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={`#${item.id}`}
                  onClick={() => setIsMenuOpen(false)}
                  className="block text-left text-sm text-primary hover:text-accent transition-colors py-1"
                >
                  {item.label}
                </a>
              ))}
              <Button
                size="sm"
                className="bg-primary hover:bg-primary-hover text-primary-foreground rounded-full text-sm font-medium mt-2"
                onClick={() => {
                  setIsMenuOpen(false);
                  window.open(`https://wa.me/50670473873?text=${encodeURIComponent("Hola! Me interesa conocer más sobre sus servicios.")}`, '_blank');
                }}
              >
                Hablemos
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
